import type { FC } from 'react';
import React from 'react';

import type { FilterChipConfig } from '../FilterBarV2.consts';

import { CheckboxFilterChip } from './CheckboxFilterChip';
import { MakeModelFilterChip } from './MakeModelFilterChip';
import { RangeFilterChip } from './RangeFilterChip';

interface FilterChipRendererProps {
	chipConfig: FilterChipConfig;
}

export const FilterChipRenderer: FC<FilterChipRendererProps> = ({ chipConfig }) => {
	if (chipConfig.type === 'makeModel') return <MakeModelFilterChip chipConfig={chipConfig} />;
	if (chipConfig.type === 'range' || chipConfig.type === 'singleValueRange')
		return <RangeFilterChip chipConfig={chipConfig} />;
	return <CheckboxFilterChip chipConfig={chipConfig} />;
};
